import { Accordion, AccordionDetails, Grid, Typography } from '@mui/material';
import { ExpandMore } from '@mui/icons-material';
import { PmiButton } from 'shell/components/shared/button';
import { useState } from 'react';
import { FormikProps } from 'formik';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { FiltersFormService } from 'system/pages/services/list/types';
import PmiTextField from 'shell/components/shared/text-field';

interface FiltersServiceProps {
  filterServiceForm: FormikProps<FiltersFormService>;
}

const FiltersService = ({ filterServiceForm }: FiltersServiceProps): React.ReactElement => {
  const [open, setOpen] = useState<boolean>(true);

  return (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-services-content"
        id="panel-services-header"
        classes={{
          root: 'pmi-flex-row-reverse',
        }}
        expandIcon={<ExpandMore />}
      >
        <Typography>Filtri</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <form onSubmit={filterServiceForm.handleSubmit}>
          <Grid container spacing={2} alignItems="center">
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Codice servizio"
                label="Codice"
                id="code"
                name="code"
                fullWidth
                type="text"
                variant="outlined"
                value={filterServiceForm.values.code}
                onChange={filterServiceForm.handleChange}
                error={filterServiceForm.touched.code && Boolean(filterServiceForm.errors.code)}
                helperText={filterServiceForm.errors.code}
                inputProps={{
                  maxLength: '4',
                }}
              />
            </Grid>
            <Grid item xs={12} md={4}>
              <PmiTextField
                aria-label="Descrizione servizio"
                label="Descrizione"
                id="description"
                name="description"
                fullWidth
                type="text"
                variant="outlined"
                value={filterServiceForm.values.description}
                onChange={filterServiceForm.handleChange}
                error={
                  filterServiceForm.touched.description &&
                  Boolean(filterServiceForm.errors.description)
                }
                helperText={filterServiceForm.errors.description}
                inputProps={{
                  maxLength: '50',
                }}
              />
            </Grid>
            <Grid item xs>
              <PmiButton
                variant="contained"
                color="secondary"
                type="submit"
                disabled={!filterServiceForm.isValid}
              >
                Cerca
              </PmiButton>
            </Grid>
          </Grid>
        </form>
      </AccordionDetails>
    </Accordion>
  );
};

FiltersService.displayName = 'Filters Service component';

export default FiltersService;
